/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_ArchitectureInputs */

const en_billing_architecture = /** @type {(inputs: Billing_ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing Architecture`)
};

const es_billing_architecture = /** @type {(inputs: Billing_ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitectura de Facturación`)
};

const fr_billing_architecture = /** @type {(inputs: Billing_ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architecture de facturation`)
};

const de_billing_architecture = /** @type {(inputs: Billing_ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrechnungsarchitektur`)
};

const id_billing_architecture = /** @type {(inputs: Billing_ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arsitektur Penagihan`)
};

/** @type {(inputs: Billing_ArchitectureInputs) => LocalizedString} */
const ja_billing_architecture = en_billing_architecture;

/** @type {(inputs: Billing_ArchitectureInputs) => LocalizedString} */
const zh_billing_architecture = en_billing_architecture;

/** @type {(inputs: Billing_ArchitectureInputs) => LocalizedString} */
const ar_billing_architecture = en_billing_architecture;

/** @type {(inputs: Billing_ArchitectureInputs) => LocalizedString} */
const it_billing_architecture = en_billing_architecture;

/** @type {(inputs: Billing_ArchitectureInputs) => LocalizedString} */
const ru_billing_architecture = en_billing_architecture;

/** @type {(inputs: Billing_ArchitectureInputs) => LocalizedString} */
const pt_billing_architecture = en_billing_architecture;

/** @type {(inputs: Billing_ArchitectureInputs) => LocalizedString} */
const ko_billing_architecture = en_billing_architecture;

/**
* | output |
* | --- |
* | "Billing Architecture" |
*
* @param {Billing_ArchitectureInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const billing_architecture = /** @type {((inputs?: Billing_ArchitectureInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_ArchitectureInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_architecture(inputs)
	if (locale === "es") return es_billing_architecture(inputs)
	if (locale === "fr") return fr_billing_architecture(inputs)
	if (locale === "de") return de_billing_architecture(inputs)
	if (locale === "ja") return ja_billing_architecture(inputs)
	if (locale === "zh") return zh_billing_architecture(inputs)
	if (locale === "ar") return ar_billing_architecture(inputs)
	if (locale === "id") return id_billing_architecture(inputs)
	if (locale === "it") return it_billing_architecture(inputs)
	if (locale === "ru") return ru_billing_architecture(inputs)
	if (locale === "pt") return pt_billing_architecture(inputs)
	return ko_billing_architecture(inputs)
});